<template>
  <div class="breadcrumbs">
    <span>Компании</span>
    <i class="el-icon-arrow-right"></i>
    <span>{{ company }}</span>
    <i class="el-icon-arrow-right"></i>
    <span class="breadcrumbs__current">{{ section }}</span>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    company: {
      type: String,
      default: ''
    },
    section: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #7A8794;
  margin-bottom: 10px;
}
.breadcrumbs i {
  font-size: 11px;
}
.breadcrumbs__current {
  color: #2D3436;
  font-weight: 500;
}
</style>
